import type { Row } from "@tanstack/react-table";

export const numericFilterFn = <R>(
  row: Row<R>,
  columnId: string,
  filterValue: [number | undefined, number | undefined],
) => {
  const [min, max] = filterValue;

  const cellValue = Number(row.getValue(columnId));

  if (typeof min === "number" && typeof max === "number") {
    return cellValue >= min && cellValue <= max;
  }

  if (typeof min === "number") {
    return cellValue >= min;
  }

  if (typeof max === "number") {
    return cellValue <= max;
  }

  return true;
};
